import { createContext, useContext } from 'react'
import { type AICallingAgentManageStore } from '../store/AICallingAgentManageStore'

export const AICallingAgentManageContext = createContext<AICallingAgentManageStore | null>(null)

export const useAICallingAgentManageContext = () => {
  const context = useContext(AICallingAgentManageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with AICallingAgentManageContext'
    )

  return context
}
